import { useSelector, useDispatch } from 'react-redux'
import { Link } from '../misc/Link'
import handleFulltextClick from '../../lib/handle-full-text-click'
import { fetchFullTextLink, updateAccessLog } from '../../store/ui/actions'
import CircleSpinner from './CircleSpinner'
import { useEffect } from 'react'

const FullTextLink = ({
  doi,
  issns,
  memberId,
  className
}) => {
  const dispatch = useDispatch()
  const user = useSelector(({ ui }) => ui.user)
  const fullTextLinkState = useSelector(({ ui }) => ui.fullTextLinkState)

  const linkState = fullTextLinkState[doi]
  const requiresFetching = user?.organizationLicense || CONFIG?.memberIDsWithCustomLinkLogic.includes(memberId)

  useEffect(() => {
    if (requiresFetching && !linkState && doi) {
      dispatch(fetchFullTextLink(doi, memberId))
    }
  }, [requiresFetching])

  const handleClick = (e) => {
    handleFulltextClick({ doi, issns, memberId })
    if (user?.organizationLicense) {
      dispatch(updateAccessLog(doi, linkState.linkURL))
    }
  }

  if (!requiresFetching || !linkState) {
    const doiLink = `https://doi.org/${doi}`
    return (
      <Link blue underline className={className} onClick={handleClick} href={doiLink} target='_blank' rel='noopener noreferrer nofollow'>
        View full text
      </Link>
    )
  }
  return linkState?.loading
    ? (
      <CircleSpinner size={25} />
      )
    : (
      <Link blue underline className={className} onClick={handleClick} href={linkState.linkURL} target='_blank' rel='noopener noreferrer nofollow'>
        {linkState.linkText}
      </Link>
      )
}
export default FullTextLink
